import React, { useEffect, useState } from "react";

const COLORS = ["#C36442", "#2A4B42", "#E7C47C", "#7a6a5a", "#0F4C75", "#A23B72"];

function initials(name) {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function colorFor(name) {
  let hash = 0;
  for (const ch of String(name || "")) hash = (hash * 31 + ch.charCodeAt(0)) | 0;
  return COLORS[Math.abs(hash) % COLORS.length];
}

/**
 * Universal user avatar. Renders the user's uploaded image when available,
 * otherwise their initials on a deterministic colored circle.
 * Pass either `user: {id, name, avatar_url}` OR raw `name` + `avatarUrl`.
 * When only an `id` is known we try the backend avatar endpoint and fall
 * back to initials if the user never uploaded a picture (404).
 */
export default function UserAvatar({ user, name, avatarUrl, size = 40, className = "", testId }) {
  const displayName = (user && user.name) || name || "Friend";
  const explicitUrl = avatarUrl || (user && user.avatar_url);
  const idUrl = !explicitUrl && user && user.id ? `/api/users/${user.id}/avatar` : null;
  const raw = explicitUrl || idUrl;
  const fullUrl = raw && !raw.startsWith("http")
    ? `${process.env.REACT_APP_BACKEND_URL}${raw}`
    : raw;
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [fullUrl]);
  const showImg = !!fullUrl && !failed;
  return (
    <div
      data-testid={testId}
      className={`shrink-0 rounded-full overflow-hidden grid place-items-center text-cream font-semibold select-none ${className}`}
      style={{ width: size, height: size, background: showImg ? "#eee" : colorFor(displayName), fontSize: size * 0.4 }}
      aria-label={displayName}
    >
      {showImg ? (
        <img src={fullUrl} alt={displayName} className="w-full h-full object-cover" onError={() => setFailed(true)} />
      ) : (
        <span>{initials(displayName)}</span>
      )}
    </div>
  );
}
